import { put, takeLatest, delay } from "redux-saga/effects";
import { postLoginApi } from "store/api/LoginApi";
import { LOGIN_REQUEST } from "../../actions/LoginPageAction/actionTypes";
import { DOMAIN } from "services/KidoConfigApi";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postLogin(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield postLoginApi(action.params);
	try {
		if (res?.code === 0) {
			yield showMessage(false, res?.message);
			localStorage.setItem("token", res?.data?.token);
			window.location.replace(`${DOMAIN}/home`);
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postLoginSaga() {
	yield takeLatest(LOGIN_REQUEST, postLogin);
}

export default postLoginSaga;
